var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon, IconName, IconSize, Stepper } from "@eightfold.ai/octuple";
import styles from "./StepManager.module.scss";
import { createElement, useRef, useState } from "react";
// eslint-disable-next-line @typescript-eslint/no-empty-function
export var editing = { has: function () { return true; }, add: function () { } };
var Pencil = function (_a) {
    var onClick = _a.onClick;
    return (_jsx("div", __assign({ className: styles.pencil, onClick: onClick }, { children: _jsx(Icon, { path: IconName.mdiPencil, size: IconSize.Medium }) })));
};
export var StepManager = function (props) {
    var _a = useState(0), onStep = _a[0], setOnStep = _a[1];
    var seenSteps = useRef(new Set());
    seenSteps.current.add(onStep);
    var hasStep = function (step) { var _a, _b; return (_b = (_a = props === null || props === void 0 ? void 0 : props.seenSteps) === null || _a === void 0 ? void 0 : _a.has(step)) !== null && _b !== void 0 ? _b : seenSteps.current.has(step); };
    var seenKey = props.steps.map(function (_, index) { return hasStep(index); }).join("-");
    var steps = props.steps.map(function (_a, index) {
        var content = _a.content, title = _a.title, closeContent = _a.closeContent, pencil = _a.pencil, back = _a.back, done = _a.done;
        return ({
            content: (_jsxs("div", __assign({ className: styles.content }, { children: [_jsxs("div", __assign({ className: styles.title }, { children: [_jsx("div", { children: title }), onStep !== index &&
                                hasStep(index) &&
                                (pencil ? (createElement(pencil, { onClick: function () { return setOnStep(index); } })) : (_jsx(Pencil, { onClick: function () { return setOnStep(index); } })))] }), "title-".concat(index, "-").concat(seenKey)), _jsx("div", { children: onStep === index ? (createElement(content, {
                            done: function () { return (done ? done(setOnStep) : setOnStep(index + 1)); },
                            back: function () { return (back ? back(setOnStep) : setOnStep(index - 1)); },
                        })) : closeContent ? (createElement(closeContent, {})) : (_jsx("div", { className: styles.whiteSpace })) })] }), seenKey)),
        });
    });
    return (_jsx(Stepper, { index: onStep, steps: steps, layout: "vertical", classNames: styles.stepper }, "stepper-".concat(onStep, "-").concat(seenKey)));
};
